/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Saving_ProjectInputs */

const en_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving project...`)
};

const fr_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet...`)
};

const de_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt retten...`)
};

const it_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto...`)
};

const ru_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект по сохранению...`)
};

const es_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando proyecto...`)
};

const zh_cn2_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目……`)
};

const ja_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを保存しています...`)
};

const hi_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचत परियोजना...`)
};

const pt_pt2_saving_project = /** @type {(inputs: Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de economia...`)
};

/**
* | output |
* | --- |
* | "Saving project..." |
*
* @param {Saving_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const saving_project = /** @type {((inputs?: Saving_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saving_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_saving_project(inputs)
	if (locale === "de") return de_saving_project(inputs)
	if (locale === "it") return it_saving_project(inputs)
	if (locale === "ru") return ru_saving_project(inputs)
	if (locale === "es") return es_saving_project(inputs)
	if (locale === "zh-CN") return zh_cn2_saving_project(inputs)
	if (locale === "ja") return ja_saving_project(inputs)
	if (locale === "hi") return hi_saving_project(inputs)
	if (locale === "pt-PT") return pt_pt2_saving_project(inputs)
	return en_saving_project(inputs)
});